import React, { useState } from 'react';
import { Grid, Collapse } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ExpandIcon from '@square-icons/react/24/UI/chevron-down';
import CartItem from 'components/common/receipt/cart_item';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  expand: {
    cursor: 'pointer',
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
}));

const CollapsibleCart = ({ cart = [], title }) => {
  const classes = useStyles();

  const [expanded, setExpanded] = useState(true);

  const cartItems = cart.map((cartItem) => (
    <CartItem
      key={cartItem.id}
      productName={cartItem.product_variant.title}
      serialNumber={cartItem.exchange_serial_number}
      quantity={cartItem.quantity}
      cost={cartItem.price}
      currency={cartItem.currency}
      plan={cartItem.plan}
      isSoftware={cartItem.is_software}
    />
  ));

  return (
    <>
      <Grid container justifyContent="space-between" sx={{ mb: 1 }}>
        <Grid item>
          <p className="semibold-30">{title && title}</p>
        </Grid>
        <Grid item>
          <ExpandIcon
            onClick={() => setExpanded(!expanded)}
            className={clsx(classes.expand, {
              [classes.expandOpen]: expanded,
            })}
          />
        </Grid>
      </Grid>
      <Collapse
        in={expanded}
        timeout="auto"
        unmountOnExit
        id="collpase-container"
      >
        {cartItems}
      </Collapse>
    </>
  );
};

export default CollapsibleCart;
